<template>
  <div id="app">
    <!--<router-view name="header"></router-view>-->
    <c_header style="height: 250px"></c_header>
    <!--<keep-alive>-->
      <router-view name="default"></router-view>
    <!--</keep-alive>-->
    <!--<router-view name="footer"></router-view>-->
    <c_footer style="height: 180px;"></c_footer>
  </div>
</template>

<script>
  import header from '@/views/layout/Header'
  import footer from '@/views/layout/Footer'
export default {
  name: "app",
  components: {
    "c_header":header,
    "c_footer":footer
  },
  watch: {
    $route(to, from) {
      // 在mounted函数执行的方法，放到该处
      // this.$router.go(0);
    }
  }
};
</script>
<style lang="css">
#app {
  background: #f6f6f6 url("./assets/bg.png") no-repeat;
  background-size: 100% 2000px;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #009ec4;
  color: #fff;
}
.el-carousel--horizontal{
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/App.vue